import React, { Component } from 'react';
import { Modal, Space } from 'antd';
import {
    SyncOutlined,
} from '@ant-design/icons';

class LoadingModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        return (
            <Modal
                title={(this.props.isCreatingHomeVisit ? "Creando" : this.props.isEditingHomeVisit ? "Editando" : "Cargando") + " cita..."}
                open={true}
                centered={true}
                maskClosable={false}
                keyboard={false}
                closable={false}
                footer={null}
                style={{ textAlign: 'center' }}
            >
                <Space size="middle">
                    <SyncOutlined spin={true} style={{ fontSize: 36 }} />
                </Space>
            </Modal>
        );
    }
}

export default LoadingModal;



// WEBPACK FOOTER //
// ./src/views/HomeVisits/loadingModal.jsx